/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { RegularText } from '../StyledTypography';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledTableList = RegularText.withComponent('ul').extend`
  margin: 0;
  padding: 0;
  list-style: none;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledTableList/index.js